import React, { useEffect, useState } from 'react'
import "../styles/work.css"
import ReactPlayer from 'react-player';

const WorkItems = ({ item }) => {
  const [showVid, setShowVid] = useState(false)
  useEffect(() => {}, [item.video]);
  return (
    <div className="work__card" key={item.id}>
      {/* <img src={item.image} alt="workItems_img" className="work__img" /> */}
      <h3 className="work__title">{item.title}</h3>
      {/* {showVid ? (
        <>
          <div className="video__containe">
            <video
              className="video"
              controls
              autoPlay
              poster="vignette.jpg"
            >
              <source src={item.video} type="video/webm" />
            </video>
            </div>
            <span
              className="close__video"
              onClick={() => setShowVid(false)}
             
            >
              X
            </span>
          
        </>
      ) : null} */}

      {/* <span onClick={() => setShowVid(true)} className="work__button">
        Demo <i className="bx bx-right-arrow-alt work__button-icon"></i>
      </span> */}

      <div class="work-image-container">
        <div class="work-image-row">
          {/* <h2 class="work-image-text-center">Image Scroll on Hover</h2> */}
          <div class="col-md-4 col-md-offset-4 content">
            <div class="work-image-screen">
              <img src={item.image} alt="workItems_img" className="work__img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkItems